/** Stears Design System (Vector 2.0) tokens. Mirrored in tailwind.config.js. */
export const colors = {
  backgroundBody: '#1A1D21',
  backgroundMain: '#0E0F10',
  backgroundSkeleton: '#2D3036',
  backgroundInput: '#1F2937',
  borderMain: '#4B5563',
  borderHover: '#ABACAE',
  borderActive: '#85BEFF',
  borderWhite: '#FFFFFF',
  textWhite: '#FFFFFF',
  textInput: '#E5E7EB',
  textSupport: '#9CA3AF',
  textDescription: '#969696',
  textHyperlink: '#85BEFF',
  buttonPrimary: '#4B5563',
  buttonSecondary: '#1A1D21',
  buttonDestructive: '#F05042',
  success: '#22C55E',
} as const

export const spacing = {
  tiny4: 4, xxSmall8: 8, xSmall10: 10, small12: 12, med20: 20,
  large24: 24, xLarge32: 32, xxLarge40: 40, xxxLarge48: 48, jumbo64: 64,
} as const

export const BORDER = `0.5px solid ${colors.borderMain}`
